import http from "../Services/http-common";
const APIRequest = {
  POST: async function (data, url) {
    const jwtToken = localStorage.getItem("JWtToken");
    return await fetch(url, {
      mode: "cors",
      method: "POST",
      body: data,
      headers: { Authorization: `Bearer ${jwtToken}` },

    })
      .then((responce) => {
        if (responce.status == 502) {
          return "Server maintenance";
        }
        else { return responce.json(); }
      })
      .then((data) => {
        //console.log(data);
        return data;
      })
      .catch((err) => {
        console.log("error" + err);
        return err.message;
      });
  },
  POSTREFRESH: async function (url) {
    const jwtToken = localStorage.getItem("JWtToken");
    return await fetch(url, {
      mode: "cors",
      method: "POST",
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        "Content-Type": "application/json",
      },
    })
      .then((responce) => {
        if (responce.status == 502) {
          return "Server maintenance";
        }
        else { return responce.json(); }
      })
      .then((data) => {
        localStorage.setItem('JWtToken', data.jwt);
        return data;
      })
      .catch((err) => {
        console.log("error" + err);
        return err.message;
      });
  },
  DELETE: async function (url) {
    const jwtToken = localStorage.getItem("JWtToken");
    return await fetch(url, {
      mode: "cors",
      method: "DELETE",
      headers: { Authorization: `Bearer ${jwtToken}` },
    })
      .then((responce) => {
        if (responce.status == 502) {
          return "Server maintenance";
        }
        else {
          return responce.json();
        }
      })
      .then((data) => {
        //console.log(data);
        return data;
      })
      .catch((err) => {
        console.log("error" + err.message);
        return err.message;
      });
  },
  PUT: async function (data, url) {
    const jwtToken = localStorage.getItem("JWtToken");
    return await fetch(url, {
      mode: "cors",
      method: "PUT",
      body: data,
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        "Content-Type": "application/json"

      }
    })
      .then((responce) => {
        if (responce.status == 200) return responce;
        else {
          if (responce.status == 502) {
            return "Server maintenance";
          }
          else {
            return responce.json();
          }
        };
      })
      .then((data) => {
        //console.log(data);
        return data;
      })
      .catch((err) => {
        console.log("error" + err.message);
        return err.message;
      });
  },
  PUTControlStatus: async function (data, url) {
    const jwtToken = localStorage.getItem("JWtToken");
    return await fetch(url, {
      mode: "cors",
      method: "PUT",
      body: data,
      headers: {
        Authorization: `Bearer ${jwtToken}`//,
        //"Content-Type": "application/json"

      }
    })
      .then((responce) => {
        if (responce.status == 200) return responce;
        else {
          if (responce.status == 502) {
            return "Server maintenance";
          }
          else {
            return responce.json();
          }
        };
      })
      .then((data) => {
        //console.log(data);
        return data;
      })
      .catch((err) => {
        console.log("error" + err.message);
        return err.message;
      });
  },
  GET: async function (data, url) {
    const jwtToken = localStorage.getItem("JWtToken");
    return await fetch(url, {
      mode: "cors",
      method: "GET",
      headers: { Authorization: `Bearer ${jwtToken}` },
    })
      .then((responce) => {
        if (responce.status == 502) {
          return "Server maintenance";
        }
        else {
          return responce.json();
        }
      })
      .then((data) => {
        //console.log(data);
        return data;
      })
      .catch((err) => {
        console.log("error" + err.message);
        return err.message;
      });
  },
  GetRdocsData: async function (objRDocsDocumentDetails) {
    const config = {
      headers: {
        "Content-type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("JWtToken")}`,
      },
    };
    return await http.post('/GetSendToRDocsData', { DocumentId: objRDocsDocumentDetails.DocumentId }, config).then(response => {

      if (response.status == 502) {
        return "Server maintenance";
      }
      else { return response; }

    }).catch(error => {
      console.log(error.message);
      return error.message;
    });
  },
  POSTSaveSettings: async function (data, url) {
    const jwtToken = localStorage.getItem("JWtToken");
    return await fetch(url, {
      mode: "cors",
      method: "POST",
      body: data,
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        "Content-Type": "application/json"
      },
    })
      .then((responce) => {
        if (responce.status == 502) {
          return "Server maintenance";
        }
        else { return responce.json() }
      })
      .then((data) => {
        //console.log(data);
        return data;
      })
      .catch((err) => {
        console.log("error" + err);
        return err.message;
      });
  },
  POSTSave: async function (lstTableColumnSettings, url) {
    const jwtToken = localStorage.getItem("JWtToken");
    try {
      const response = await fetch(url, {
        mode: "cors",
        method: "POST",
        body: JSON.stringify(lstTableColumnSettings),
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          "Content-Type": "application/json"
        }
      });
      if (response.status === 502) {
        return "Server maintenance";
      }
      const text = await response.text();
      return text ? JSON.parse(text) : null;

    } catch (err) {
      console.error("Fetch error:", err);
      return err.message;
    }
  }
};
export default APIRequest;
